// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Plus,
  Search,
  Users,
  X,
  Upload,
  Download,
  TriangleAlert,
  Eye,
  Archive,
  CheckCircle,
  LockKeyhole,
  LockKeyholeOpen,
} from "lucide-react";
import {
  Clock,
  User,
  Calendar,
  Edit3,
  Tag,
  Stethoscope,
  Heart,
  FileText,
} from "lucide-react";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { toast } from "sonner";
import { useSearchParams, useNavigate, useLocation } from "react-router";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Label } from "@/components/ui/label";
import * as XLSX from "xlsx";
import { isPermissionNavRole, useAuth } from "@/contexts/use-auth";
import { useDebouncedInput } from "@/hooks/useDebouncedInput";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useGetData } from "@/hooks/useGetData";
import { useOrg } from "@/contexts/useOrg";
import LoaderWrapper from "./LoaderWrapper";
import TableWithSearch from "@/components/TableWithSearch";
import {
  needsVerificationPatientTableHeaders,
  patientTableHeaders,
} from "@/utils/tablesData";
import { useGetSearchParams } from "@/hooks/useGetSearchParams";
import {
  checkOptOutcondition,
  getCurrentMonthYear,
  getPromise,
  getPromiseToast,
  formatDate,
  formatPatientListStatus,
  getPatientContextTimezoneDisplay,
  formatOrganizationTimezoneDisplay,
  getErrToast,
} from "@/utils/helpers";
import RHFWrapper from "@/components/RHFWrapper";
import MyDialogContent from "@/components/MyDialogContent";
import RhfSelect from "@/components/rhfFields/RhfSelect";
import RhfInput from "@/components/rhfFields/RhfInput";
import { PatientBulkStatusChange } from "@/components/PatientBulkStatusChange";
import AxiosInstance from "@/utils/AxiosInstance";
import axios from "axios";
import { Textarea } from "@/components/ui/textarea";
// import React, { } from "react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import MyTable from "@/components/MyTable";
import NursingNoteTablePopup from "@/components/NursingNoteTablePopup";
import EnrollNotesConsentForm from "@/components/EnrollNotesConsentForm";

type PatientsView =
 "enrolled" | "eligible" 
//  | "needs_verification";

function parsePatientsView(raw: unknown): PatientsView | null {
  const value = String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_");
  if (value === "eligible") return "eligible";
  if (value === "enrolled") return "enrolled";
  // if (
  //   value === "needs_verification" ||
  //   value === "needsverification" ||
  //   value === "verification"
  // ) {
  //   return "needs_verification";
  // }
  return null;
}

function formatEligibleForRpm(value: unknown) {
  if (value === true || value === 1) return "YES";
  if (value === false || value === 0) return "NO";
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();
  if (["yes", "y", "true", "1"].includes(normalized)) return "YES";
  if (["no", "n", "false", "0"].includes(normalized)) return "NO";
  return value == null || String(value).trim() === "" ? "-" : String(value);
}

function getIcdCodesCount(patient: any) {
  if (typeof patient?.icdCodesCount === "number") return patient.icdCodesCount;
  if (typeof patient?.noOfIcdCodes === "number") return patient.noOfIcdCodes;
  if (typeof patient?.numberOfIcdCodes === "number") return patient.numberOfIcdCodes;
  if (Array.isArray(patient?.icdCodes)) return patient.icdCodes.length;
  if (Array.isArray(patient?.icd10Codes)) return patient.icd10Codes.length;
  const parsed = Number(patient?.icdCodesCount ?? patient?.noOfIcdCodes);
  return Number.isFinite(parsed) ? parsed : 0;
}

const NEEDS_VERIFICATION_ORG_ID = "1ca63f50-b211-40fa-b87f-ee3076425f83";
const NEEDS_VERIFICATION_FETCH_URL = import.meta.env.DEV
  ? `/ehr-api/${NEEDS_VERIFICATION_ORG_ID}/patient/fetch`
  : `https://kdtugu8byq.us-east-1.awsapprunner.com/api/${NEEDS_VERIFICATION_ORG_ID}/patient/fetch`;

function formatNeedsVerificationGender(value: unknown) {
  const raw = String(value ?? "").trim();
  if (!raw) return "-";
  return raw
    .toLowerCase()
    .split(/[_\s]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function mapNeedsVerificationPatient(v: any) {
  return {
    ...v,
    _id: v?.id,
    athenaId: v?.externalId || "-",
    firstName: `${v?.firstName || ""} ${v?.lastName || ""}`.trim() || "-",
    email: v?.email || "-",
    dateOfBirth: formatDate(v?.birthDate),
    primaryNumber: v?.mobilePhone || "-",
    typeOfPatient: v?.typeOfPatient || "-",
    weightValue: v?.weightValue ?? "-",
    gender: formatNeedsVerificationGender(v?.gender),
    eligibleForRpm: formatEligibleForRpm(
      v?.eligibleForRpm ?? v?.eligibleForRPM ?? v?.rpmEligible,
    ),
    icdCodesCount:
      v?.icdCodes ||
      v?.icd10Codes ||
      v?.icdCodesCount != null ||
      v?.noOfIcdCodes != null
        ? getIcdCodesCount(v)
        : "-",
  };
}

async function fetchNeedsVerificationPatients({
  page,
  limit,
}: {
  page: number;
  limit: number;
}) {
  const { data } = await axios.get(NEEDS_VERIFICATION_FETCH_URL, {
    params: {
      page: Math.max(0, page - 1),
      size: limit,
    },
    headers: {
      accept: "application/json",
      "X-API-Version": "1.0.0",
    },
  });
  const payload = data?.data;
  return {
    data: Array.isArray(payload?.content) ? payload.content : [],
    totalPages: payload?.pagination?.totalPages,
    total: payload?.pagination?.totalElements,
  };
}

async function fetchAllNeedsVerificationPatients() {
  const pageSize = 200;
  const first = await fetchNeedsVerificationPatients({
    page: 1,
    limit: pageSize,
  });
  const rows = [...first.data];
  const totalPages = Number(first.totalPages) || 1;
  for (let nextPage = 2; nextPage <= totalPages; nextPage++) {
    const next = await fetchNeedsVerificationPatients({
      page: nextPage,
      limit: pageSize,
    });
    rows.push(...next.data);
  }
  return rows;
}

/** Dashboard "Other" tile — enrolled patients outside active/pending buckets */
const ENROLLED_NON_ACTIVE_STATUSES = [
  "inactive",
  "archived",
  "denied",
  "blocked",
  "newly_added",
  "non_compliant",
];

/** Handles `refilter='other'`, newlines in query, stray quotes */
function normalizeRefilterQuery(raw: string) {
  return String(raw ?? "")
    .replace(/\s+/g, "")
    .replace(/^['"]+|['"]+$/g, "")
    .toLowerCase();
}

export default function Patients() {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    input: search,
    setInput: setSearch,
    debouncedInput,
  } = useDebouncedInput("", 500);
  const [statusFilter, setStatusFilter] = useState(
    searchParams.get("status") || "",
  );
  const [patientTypeFilter, setPatientTypeFilter] = useState(
    searchParams.get("patientType") || "",
  );
  const [caretakerFilter, setCaretakerFilter] = useState<string[] | null>(
    searchParams.get("caretakerId") ? [searchParams.get("caretakerId")!] : null,
  );
  const refilterRaw = searchParams.get("refilter") || "";

  const navigate = useNavigate();
  // console.log({
  //   statusFilter,
  //   patientTypeFilter,
  //   facilityFilter,
  //   caretakerFilter,
  // });

  // Using dummy data - replace with actual API calls
  const { user, profile: profileFromAuth, isLoading: authLoading } = useAuth();
  const [profile, setProfile] = useState<any>(null);
  const isCaretaker = user?.role === "caretaker";

  useEffect(() => {
    if (!authLoading && user) {
      if (profileFromAuth) {
        setProfile(profileFromAuth);
      } else if (isCaretaker) {
        const fetchProfile = async () => {
          try {
            const response = await AxiosInstance().get<any>("/auth/me");
            const responseData = response?.data as any;
            if (responseData?.data?.profile) {
              setProfile(responseData.data.profile);
            }
          } catch (error) {
            console.error("Error fetching profile:", error);
          }
        };
        fetchProfile();
      }
    }
  }, [user, profileFromAuth, authLoading, isCaretaker]);

  const isCaretakerAssignedToPatient = (rowData: any) => {
    if (!isCaretaker) return true;
    const patient = patients.find((p: any) => p._id === rowData?._id) || rowData;
    const assignedCaretakerIds = (patient?.assignedCaretakerIds || []).map((v: any) => typeof v === "string" ? v : v?._id);
    const profileId = profile?._id;
    if (!profileId) return false;
    return assignedCaretakerIds.includes(profileId);
  };

  const { selectedOrgId, isAllSelected } = useOrg();
  const [patients, setPatients] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [providers, setProviders] = useState([]);
  const location = useLocation();
  const { state } = location;

  const [patientsView, setPatientsView] = useState<PatientsView>(() => {
    return (
      parsePatientsView(searchParams.get("view")) ||
      parsePatientsView(state?.patientsView) ||
      "enrolled"
    );
  });

  // URL se tab set: ?status=active → Enrolled, ?status=pending → Eligible; phir status param hata do
  useEffect(() => {
    const status = searchParams.get("status");
    if (status === "active") {
      setPatientsView("enrolled");
    } else if (status === "pending") {
      setPatientsView("eligible");
    }
    if (status === "active" || status === "pending") {
      const params = new URLSearchParams(searchParams.toString());
      params.delete("status");
      // keep current tab in URL for back navigation
      params.set("view", status === "pending" ? "eligible" : "enrolled");
      const search = params.toString();
      if (search) setSearchParams(params);
      else navigate(location.pathname || "/patients", { replace: true });
    }
  }, [searchParams]);


  // const { loading: patientLoading, err: patientErr } = useGetData(
  //   "/patients",
  //   {
  //     orgId: selectedOrgId,
  //     enrollmentStatus: patientsView,
  //     ...(statusFilter ? { status: statusFilter } : {}),
  //     ...(patientTypeFilter ? { patientType: patientTypeFilter } : {}),
  //     ...(facilityFilter ? { faciltyId: facilityFilter } : {}),
  //     ...(caretakerFilter ? { caretakerId: caretakerFilter } : {}),
  //   },
  //   false,
  //   !!selectedOrgId,
  //   (err, data) => {
  //     if (data && !err) {
  //       setPatients(data?.data?.patients);
  //     }
  //   },
  // );
  const { apiData } = useGetData(
    "/caretakers",
    { orgId: selectedOrgId, limit: 200 },
    false,
    true,
  );
  const caretakers = apiData?.data?.caretakers || [];

  useGetData(
    "/facilities",
    { orgId: selectedOrgId, limit: 500 },
    false,
    !!selectedOrgId && !isAllSelected && selectedOrgId !== "anthro-care",
    (err, data) => {
      if (!err && data?.data?.facilities) {
        setFacilities(data.data.facilities);
      } else {
        setFacilities([]);
      }
    },
  );

  useEffect(() => {
    if (!selectedOrgId || isAllSelected || selectedOrgId === "anthro-care") {
      setFacilities([]);
    }
  }, [selectedOrgId, isAllSelected]);

  const clearCaretakerFilter = () => {
    setCaretakerFilter(null);
    const params = new URLSearchParams(searchParams.toString());
    params.delete("caretakerId");
    params.set("view", patientsView);
    setSearchParams(params);
  };

  return (
    // <DashboardLayout activePage="/patients">
    <PatientsContent
      selectedOrgId={selectedOrgId}
      isAllSelected={isAllSelected}
      searchParams={searchParams}
      setSearchParams={setSearchParams}
      refilter={refilterRaw}
      search={search}
      setSearch={setSearch}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      patientTypeFilter={patientTypeFilter}
      setPatientTypeFilter={setPatientTypeFilter}
      caretakerFilter={caretakerFilter}
      setCaretakerFilter={setCaretakerFilter}
      clearCaretakerFilter={clearCaretakerFilter}
      organizations={organizations}
      caretakers={caretakers}
      facilities={facilities}
      providers={providers}
      patients={patients}
      setPatients={setPatients}
      user={user}
      navigate={navigate}
      loading={false}
      error={false}
      patientsView={patientsView}
      setPatientsView={setPatientsView}
      state={state}
      urlStatus={searchParams.get("status") ?? undefined}
      isCaretaker={isCaretaker}
      isCaretakerAssignedToPatient={isCaretakerAssignedToPatient}
    />
    // </DashboardLayout>
  );
}

function PatientsContent({
  selectedOrgId,
  isAllSelected,
  searchParams,
  setSearchParams,
  refilter,
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  patientTypeFilter,
  setPatientTypeFilter,
  caretakerFilter,
  setCaretakerFilter,
  clearCaretakerFilter,
  organizations,
  caretakers,
  facilities,
  providers,
  patients,
  setPatients,
  user,
  navigate,
  loading,
  error,
  patientsView,
  setPatientsView,
  state,
  urlStatus,
  isCaretaker = false,
  isCaretakerAssignedToPatient = () => true,
}: {
  selectedOrgId: string | null;
  isAllSelected: boolean;
  searchParams: URLSearchParams;
  setSearchParams: any;
  refilter: string;
  search: string;
  setSearch: (value: string) => void;
  statusFilter: string;
  setStatusFilter: (value: string) => void;
  patientTypeFilter: string;
  setPatientTypeFilter: (value: string) => void;
  caretakerFilter: string[] | null;
  setCaretakerFilter: (value: string[] | null) => void;
  clearCaretakerFilter: () => void;
  organizations: any;
  caretakers: any;
  facilities: any;
  providers: any;
  patients: any;
  user: any;
  navigate: any;
  loading: boolean;
  error: any;
  patientsView: any;
  setPatientsView: () => void;
  state: any;
  urlStatus?: string | null;
  isCaretaker?: boolean;
  isCaretakerAssignedToPatient?: (rowData: any) => boolean;
}) {
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [openOptOut, setOpenOptOut] = useState(false);
  const [openEnrollNotes, setOpenEnrollNotes] = useState(false);
  const [openOptOutForm, setOpenOptOutForm] = useState(false);
  const [openArchiveConfirm, setOpenArchiveConfirm] = useState([false, null]);
  const [arcReason, setArcReason] = useState("");
  const [openActivateConfirm, setOpenActivateConfirm] = useState(false);
  const [selectedPatientForEnroll, setSelectedPatientForEnroll] =
    useState<any>(null);
  const [selectedPatientForOptOut, setSelectedPatientForOptOut] =
    useState<any>(null);
  const [selectedPatientForArchive, setSelectedPatientForArchive] =
    useState<any>(null);
  const [selectedPatientForActivate, setSelectedPatientForActivate] =
    useState<any>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isPendingExporting, setIsPendingExporting] = useState(false);
  const [isNeedsVerificationExporting, setIsNeedsVerificationExporting] =
    useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const isProviderOrPractitioner = useMemo(() => user?.role === 'provider' || user?.role === 'practitioner', [user?.role]);
  const isProviderOrPractitionerManager = useMemo(() => user?.role === 'manager' && (user?.managerScope === 'provider' || user?.managerScope === 'practitioner'), [user?.role]);
  //  console.log('isProviderOrPractitionerManager', isProviderOrPractitionerManager);
  // Persist initial URL intent even after we remove `?status=` from the URL.
  // Without this, later effects can restore enrolled default statuses and UI shows extra selections.
  const [urlStatusIntent] = useState<"activeOnly" | "eligibleOnly" | null>(() => {
    if (urlStatus === "active") return "activeOnly";
    if (urlStatus === "pending") return "eligibleOnly";
    return null;
  });

  const [otherFilterIntent, setOtherFilterIntent] = useState(
    () => normalizeRefilterQuery(refilter) === "other",
  );

  // Initial filters: if patientsView is "eligible", don't add status filter
  const [filters, setFilters] = useState(() => {
    const baseFilters = {
      date: getCurrentMonthYear(),
      ...(state?.filters ? state.filters : {}),
    };
    if (normalizeRefilterQuery(refilter) === "other") {
      return { ...baseFilters, status: [...ENROLLED_NON_ACTIVE_STATUSES] };
    }
    if (urlStatusIntent === "activeOnly") {
      return { ...baseFilters, status: ["active"] };
    }
    if (urlStatusIntent === "eligibleOnly") {
      return { date: baseFilters.date };
    }
    // Only add status filter if enrolled view (not eligible / needs verification) and state doesn't override it
    if (patientsView === "enrolled" && !state?.filter?.status) {
      return { ...baseFilters, status: ['active', 'inactive', 'newly_added'] };
    }
    // If eligible or needs verification, ensure no status filter
    return baseFilters;
  });
  console.log({filters, patientsView});
  const [lastEnrolledStatus, setLastEnrolledStatus] = useState<string[]>([
    "active",
    "inactive",
    "newly_added",
  ]);

  const caretakersFilteredasPatientType = useMemo(() => {
    const hasFacilityFilter =
      Array.isArray(filters?.facilityIds) && filters.facilityIds.length > 0;

    if (filters?.patientType === "facility" || hasFacilityFilter) {
      return caretakers?.filter((c: any) => c?.type === "facility");
    } else if (filters?.patientType === "outpatient") {
      return caretakers?.filter((c: any) => c?.type === "no_facility");
    }
    return caretakers;
  }, [caretakers, filters?.patientType, filters?.facilityIds]);
  // console.log({caretakersFilteredasPatientType});

  // URL se ?status=active aaya ho to sirf active filter set karo, ?status=pending ho to eligible filters (no status) set karo
  useEffect(() => {
    if (urlStatusIntent === "activeOnly") {
      setFilters((prev) => ({ ...prev, date: prev?.date || getCurrentMonthYear(), status: ["active"] }));
    } else if (urlStatusIntent === "eligibleOnly") {
      // Eligible view: no status filter (only date) - same as manual tab click
      setFilters((prev) => ({
        ...(Array.isArray(prev?.facilityIds) ? { facilityIds: prev.facilityIds } : {}),
        date: getCurrentMonthYear(),
      }));
    }
  }, [urlStatusIntent]);

  // Dashboard quick filter: /patients?refilter=other (quotes / newlines tolerated)
  useEffect(() => {
    const normalized = normalizeRefilterQuery(refilter);
    if (!normalized) return;

    if (normalized === "other") {
      setOtherFilterIntent(true);
      if (patientsView !== "enrolled") setPatientsView("enrolled");
      setFilters((prev) => ({
        ...prev,
        date: prev?.date || getCurrentMonthYear(),
        status: [...ENROLLED_NON_ACTIVE_STATUSES],
      }));
    }

    const next = new URLSearchParams(searchParams.toString());
    next.delete("refilter");
    setSearchParams(next);
  }, [refilter]);

  // Jab patientsView "eligible" / "needs_verification" set ho, filters eligible ke liye set karo (manual tab click jaisa)
  // This ensures filters match the view immediately, just like manual tab click
  useEffect(() => {
    if (patientsView === "eligible" 
      // || patientsView === "needs_verification"
    ) {
      // Remove status filter for eligible / needs verification (same as manual tab click onValueChange)
      setFilters((prev) => ({
        ...(Array.isArray(prev?.facilityIds) ? { facilityIds: prev.facilityIds } : {}),
        date: prev?.date || getCurrentMonthYear(),
      }));
    } else if (patientsView === "enrolled") {
      // If URL forced active-only, do not restore default enrolled statuses.
      if (urlStatusIntent === "activeOnly") {
        setFilters((prev) => ({
          ...prev,
          date: prev?.date || getCurrentMonthYear(),
          status: ["active"],
        }));
        return;
      }
      if (otherFilterIntent) {
        setFilters((prev) => ({
          ...prev,
          date: prev?.date || getCurrentMonthYear(),
          status: [...ENROLLED_NON_ACTIVE_STATUSES],
        }));
        return;
      }
      // Enrolled view: ensure status filter exists
      setFilters((prev) => ({
        ...(Array.isArray(prev?.facilityIds) ? { facilityIds: prev.facilityIds } : {}),
        date: prev?.date || getCurrentMonthYear(),
        status: prev?.status || ["active", "inactive", "newly_added"],
      }));
    }
  }, [patientsView, urlStatusIntent, otherFilterIntent]);

  // Drop facility selections that are not in the current org's facility list
  useEffect(() => {
    setFilters((prev) => {
      if (!Array.isArray(prev?.facilityIds) || prev.facilityIds.length === 0) {
        return prev;
      }
      if (!selectedOrgId || isAllSelected || selectedOrgId === "anthro-care") {
        const next = { ...prev };
        delete next.facilityIds;
        return next;
      }
      // Wait until facilities for the org have loaded before pruning
      if (!facilities?.length) return prev;
      const validIds = new Set(facilities.map((f: any) => f?._id));
      const nextIds = prev.facilityIds.filter((id: string) => validIds.has(id));
      if (nextIds.length === prev.facilityIds.length) return prev;
      return { ...prev, facilityIds: nextIds };
    });
  }, [selectedOrgId, isAllSelected, facilities]);

  useEffect(() => {
    setFilters((prev) => {
      if (!Array.isArray(prev?.facilityIds) || prev.facilityIds.length === 0) {
        return prev;
      }
      const next = { ...prev };
      delete next.facilityIds;
      return next;
    });
  }, [selectedOrgId]);

  useEffect(() => {
    if (
      patientsView === "enrolled" &&
      Array.isArray(filters?.status) &&
      filters.status.length > 0
    ) {
      setLastEnrolledStatus(filters.status);
    }
  }, [patientsView, filters?.status]);

  // Default filters to restore when clearing (for enrolled view: active and inactive selected)
  const defaultFilters = useMemo(() => {
    if (patientsView === "enrolled") {
      return {
        date: getCurrentMonthYear(),
        status: otherFilterIntent
          ? [...ENROLLED_NON_ACTIVE_STATUSES]
          : ["active", "inactive", "newly_added"],
      };
    }
    return {
      date: getCurrentMonthYear()
    };
  }, [patientsView, otherFilterIntent]);
  
  const [nursingNotes, setNursingNotes] = useState<any>(false);
  const [nursingLoading, setNursingLoading] = useState(false);
  // console.log({ nursingNotes, filters : state });
  // const [filters, setFilters] = useState({
  //   date : getCurrentMonthYear()
  // });

  const { isAuthorized, canAccess } = useAuth();

  const canAdministerPatients =
    user?.role?.toLowerCase() === "admin" ||
    (isPermissionNavRole(user?.role) && canAccess("canAccessPatients"));

  const isAnthroCare = selectedOrgId === "anthro-care";
  const hasExportOrganizationId = Boolean(
    selectedOrgId?.trim() && !isAllSelected && !isAnthroCare,
  );
  const canExportPendingPatients =
    patientsView === "eligible" &&
    isAuthorized("canAddPatients") &&
    hasExportOrganizationId;

  const selectedCaretakers = caretakerFilter
    ? caretakers?.filter((c: any) => caretakerFilter.includes(c._id))
    : [];
  const selectedCaretakerNames =
    selectedCaretakers?.map((c: any) => c?.firstName).join(", ") || "";

  // Client-side filtering for search, status, patient type, facility, and caretaker
  const filteredPatients = patients;

  const handlePatientClick = (patientId: string) => {
    navigate(`/patients/${patientId}`);
  };

  const getCaretakerNames = (caretakerIds: Array<string>) => {
    if (!caretakerIds || caretakerIds.length === 0) return "None";
    const names = caretakerIds
      .map((id) => {
        const caretaker = caretakers?.find((c: any) => c._id === id);
        return caretaker
          ? `${caretaker.firstName} ${caretaker.lastName}`
          : null;
      })
      .filter(Boolean);
    return names.length > 0 ? names.join(", ") : "None";
  };

  const downloadTemplate = () => {
    const template = [
      {
        "First Name*": "",
        "Middle Name": "",
        "Last Name*": "",
        "Date of Birth* (YYYY-MM-DD)": "",
        "Gender* (male/female/other)": "",
        "Height* (e.g., 5'10\")": "",
        "Weight* (e.g., 180 lbs)": "",
        Email: "",
        "Primary Number*": "",
        "Secondary Number": "",
        "Landline Number": "",
        "Landline Extension": "",
        "Street*": "",
        "City*": "",
        "State*": "",
        "ZIP Code*": "",
        "Primary Insurance Name*": "",
        "Primary Insurance Number*": "",
        "Secondary Insurance Name": "",
        "Secondary Insurance Number": "",
        "Diagnosis 1*": "",
        "Diagnosis 2*": "",
        "Diagnosis 3": "",
        "Diagnosis 4": "",
        "Diagnosis 5": "",
        "Programs* (e.g., CCM, RPM)": "",
        "Type of Patient* (ccm/rpm/pcm/bhi)": "",
        "Status* (active/pending/inactive)": "",
        "Organization ID*": "",
        "Facility ID*": "",
        "Assigned Provider ID*": "",
        "Assigned Caretaker ID": "",
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(template);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");

    // Set column widths
    worksheet["!cols"] = [
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 30 },
      { wch: 15 },
      { wch: 10 },
      { wch: 10 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
    ];

    XLSX.writeFile(workbook, "patient_bulk_upload_template.xlsx");
    toast.success("Template downloaded successfully");
  };

  const handlePendingExport = async () => {
    if (!hasExportOrganizationId || !selectedOrgId) {
      return;
    }

    setIsPendingExporting(true);
    const t = toast.loading("Preparing export...");
    try {
      const { data } = await AxiosInstance().get<Blob>(
        "/patients/pending/export",
        {
          params: { orgId: selectedOrgId },
          responseType: "blob",
        },
      );

      if (data.type?.includes("application/json")) {
        const text = await data.text();
        const parsed = JSON.parse(text);
        throw new Error(parsed?.message || "Export failed");
      }

      const url = window.URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "pending_patients_export.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success("Export downloaded successfully", { id: t });
    } catch (err) {
      toast.dismiss(t);
      getErrToast('Select an organization to export pending patients.');
    } finally {
      setIsPendingExporting(false);
    }
  };

  const handleNeedsVerificationExport = async () => {
    setIsNeedsVerificationExporting(true);
    const t = toast.loading("Preparing export...");
    try {
      const rows = await fetchAllNeedsVerificationPatients();
      const exportData = rows.map((row) => {
        const mapped = mapNeedsVerificationPatient(row);
        const exported: Record<string, any> = {};
        needsVerificationPatientTableHeaders.forEach((header) => {
          exported[header.label] = mapped[header.id] ?? "";
        });
        return exported;
      });
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Needs Verification");
      XLSX.writeFile(wb, "needs_verification_patients.xlsx");
      toast.success("Export downloaded successfully", { id: t });
    } catch (error) {
      toast.dismiss(t);
      getErrToast(error);
    } finally {
      setIsNeedsVerificationExporting(false);
    }
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      if (jsonData.length === 0) {
        toast.error("The uploaded file is empty");
        setIsUploading(false);
        return;
      }

      // Map Excel columns to patient data
      const patientsData = jsonData.map((row: any) => ({
        firstName: row["First Name*"] || "",
        middleName: row["Middle Name"] || undefined,
        lastName: row["Last Name*"] || "",
        dateOfBirth: row["Date of Birth* (YYYY-MM-DD)"] || "",
        gender: row["Gender* (male/female/other)"] || "",
        heightValue: row["Height* (e.g., 5'10\")"] || "",
        weightValue: row["Weight* (e.g., 180 lbs)"] || "",
        email: row["Email"] || undefined,
        primaryNumber: row["Primary Number*"] || "",
        secondaryNumber: row["Secondary Number"] || undefined,
        landlineNumber: row["Landline Number"] || undefined,
        landlineExtension: row["Landline Extension"] || undefined,
        street: row["Street*"] || "",
        city: row["City*"] || "",
        state: row["State*"] || "",
        zipCode: row["ZIP Code*"] || "",
        primaryInsuranceName: row["Primary Insurance Name*"] || "",
        primaryInsuranceNumber: row["Primary Insurance Number*"] || "",
        secondaryInsuranceName: row["Secondary Insurance Name"] || undefined,
        secondaryInsuranceNumber:
          row["Secondary Insurance Number"] || undefined,
        dx1: row["Diagnosis 1*"] || "",
        dx2: row["Diagnosis 2*"] || "",
        dx3: row["Diagnosis 3"] || undefined,
        dx4: row["Diagnosis 4"] || undefined,
        dx5: row["Diagnosis 5"] || undefined,
        programs: row["Programs* (e.g., CCM, RPM)"] || "",
        typeOfPatient: row["Type of Patient* (ccm/rpm/pcm/bhi)"] || "",
        status: row["Status* (active/pending/inactive)"] || "",
        organizationId: row["Organization ID*"] || "",
        facilityId: row["Facility ID*"] || "",
        assignedProviderId: row["Assigned Provider ID*"] || "",
        assignedCaretakerId: row["Assigned Caretaker ID"] || undefined,
      }));

      toast.success(`Successfully processed ${patientsData.length} patient(s)`);
      console.log("Patients data to be uploaded:", patientsData);

      setIsBulkUploadOpen(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error(
        "Failed to process file: " +
          (error instanceof Error ? error.message : "Unknown error"),
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleOptOut = (data: any) => {
    setOpenOptOut(data);
  };

  const filterOptions = useMemo(() => {
    const baseFilters = [
      {
        label: "Month",
        key: "date",
        type: "monthYear" as const,
      },
      ...(patientsView === "enrolled"
        ? [
            {
              label: "Status",
              key: "status",
              isMulti: true,
              values: [
                { label: "Active", key: "active" },
                { label: "Inactive", key: "inactive" },
                // { label: "Pending", key: "pending" },
                { label: "Archived", key: "archived" },
                { label: "Opt Out", key: "denied" },
                { label: "Blocked", key: "blocked" },
                { label: "Newly Added", key: "newly_added" },
                { label: "Non Compliant", key: "non_compliant" },
              ],
            },
          ]
        : []),
      {
        label: "Patient Type",
        key: "patientType",
        isMulti: false,
        values: [
          { label: "All", key: "all" },
          { label: "Outpatient", key: "outpatient" },
          { label: "Facility", key: "facility" },
        ],
      },
      ...(selectedOrgId && !isAllSelected
        ? [
            {
              label: "Facility",
              key: "facilityIds",
              isMulti: true,
              values: facilities?.map((facility: any) => ({
                label: facility?.name || "Unnamed facility",
                key: facility?._id,
              })),
            },
            {
              label: "Caretakers",
              key: "caretakers",
              isMulti: true,
              values: caretakers?.map((care) => ({
                label: `${care?.firstName} ${care?.lastName}`,
                key: care?._id,
              })),
            },
          ]
        : []),
    ];

    return baseFilters;
  }, [caretakers, facilities, patientsView, selectedOrgId, isAllSelected]);
  const isNeedsVerificationView = patientsView === "needs_verification";
  const fetchNeedsVerificationTable = useCallback(
    async ({ page, limit }: { page: number; limit: number }) => {
      try {
        return await fetchNeedsVerificationPatients({ page, limit });
      } catch (error) {
        getErrToast(error);
        throw error;
      }
    },
    [],
  );
  const selectActions = useMemo(() => {
    const hasFacilityFilter =
      Array.isArray(filters?.facilityIds) && filters.facilityIds.length > 0;
    const actions = [];
    if (
      selectedOrgId !== "anthro-care" &&
      canAdministerPatients &&
      ((filters?.patientType && filters?.patientType !== "all") ||
        hasFacilityFilter)
    ) {
      actions.push({
        label: "Assign Caretaker",
        key: "caretakers",
        isMulti: true,
        values: caretakersFilteredasPatientType?.map((care) => ({
          label: `${care?.firstName} ${care?.lastName}`,
          key: care?._id,
        })),
      });
    }
    // actions.push({
    //   label: "Update Status",
    //   key: "status",
    //   isMulti: false,
    //   values: ["Active", "Inactive"]?.map((care) => ({
    //     label: `${care}`,
    //     key: care.toLocaleLowerCase(),
    //   })),
    // });
    return actions;
  }, [
    caretakers,
    caretakersFilteredasPatientType,
    patientsView,
    selectedOrgId,
    isAllSelected,
    user?.role,
    filters?.patientType,
    filters?.facilityIds,
    canAdministerPatients,
  ]);

  async function assignCaretakers(selected: any, caretakerIds: string[], cb: any) {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      const caretakerIdsArr = Array.isArray(caretakerIds)
        ? caretakerIds
        : [caretakerIds];
      const hasFacilityFilter =
        Array.isArray(filters?.facilityIds) && filters.facilityIds.length > 0;
      const patientType =
        filters?.patientType && filters.patientType !== "all"
          ? filters.patientType
          : hasFacilityFilter
            ? "facility"
            : undefined;
      const selectAllFlag = selected?.selectAll === true;
      const body = selectAllFlag
        ? {
            selectAll: true,
            organizationId: selectedOrgId,
            ...(patientType ? { patientType } : {}),
            unselectedPatientIds: Array.isArray(selected?.unselectedPatientIds)
              ? selected.unselectedPatientIds
              : [],
            caretakerIds: caretakerIdsArr,
          }
        : {
            selectAll: false,
            ...(patientType ? { patientType } : {}),
            patientIds: Array.isArray(selected)
              ? selected
              : Array.isArray(selected?.patientIds)
                ? selected.patientIds
                : [],
            caretakerIds: caretakerIdsArr,
          };
      
      await AxiosInstance().post("/patients/bulk/caretakers", body);
      cb && cb();
      resolveFn("Caretaker assigned successfully");
      // Refresh the patient list
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      rejectFn(error);
    }
  }

  async function updateBulkStatus(selected: any, status: string, cb: any) {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      const selectAllFlag = selected?.selectAll === true;
      const body = selectAllFlag
        ? {
            selectAll: true,
            unselectedPatientIds: Array.isArray(selected?.unselectedPatientIds)
              ? selected.unselectedPatientIds
              : [],
            status: status,
            reason: "Bulk status update",
          }
        : {
            selectAll: false,
            patientIds: Array.isArray(selected)
              ? selected
              : Array.isArray(selected?.patientIds)
                ? selected.patientIds
                : [],
            status: status,
            reason: "Bulk status update",
          };

      await AxiosInstance().post("/patients/bulk/status", body);
      cb && cb();
      resolveFn("Status updated successfully");
      // Refresh the patient list
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      rejectFn(error);
    }
  }

  const handleSearchActionsClicked = (selected: any, key, value, cb) => {
    console.log({ selected, key, value });
    if (key == "caretakers") {
      assignCaretakers(selected, value, cb);
    }
    if(key == "status"){
      updateBulkStatus(selected, value, cb);
    }
  };

  const acceptOptOut = async (id: any, note: string, accept: boolean) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      const { data } = await AxiosInstance().post(
        "/program-removal/review/" + id,
        { reviewNote: note, action: accept ? "approved" : "rejected" },
      );
      resolveFn("Opt-Out request reviewed successfully");
      setOpenOptOut(null);
    } catch (error) {
      rejectFn(error);
    }
  };
  const nav = useNavigate();

  return (
    <DashboardLayout
      activePage="/patients"
      rightcomponent={
        <div className="flex overflow-x-auto items-center gap-2">
          <>
          {/* {canAdministerPatients && !isProviderOrPractitionerManager && (
            <Button
              onClick={() => nav("/patients/opt-out")}
              variant={"outline"}
            >
              Opt Out Requests
            </Button>
          )} */}
          </>
          {isAuthorized("canAddPatients") && (
            <div className="flex gap-2 w-full sm:w-auto">
              <PatientBulkStatusChange
                className="flex-1 sm:flex-initial"
                onSuccess={() => setRefreshKey((prev) => prev + 1)}
              />
              <Button
                className="flex-1 sm:flex-initial"
                onClick={() => navigate("/patients/add")}
              >
                <Plus className="w-4 h-4 " />
                 Patient
              </Button>
            </div>
          )}
        </div>
      }
    >
      <div className="">
        <div className="mb-4">
          <ToggleGroup
            type="single"
            value={patientsView}
            onValueChange={(value) => {
              if (value) {
                const nextView = value as PatientsView;
                setPatientsView(nextView);
                // Persist tab selection in URL so Back keeps same tab
                const params = new URLSearchParams(searchParams.toString());
                params.set("view", nextView);
                setSearchParams(params);
              }
              setFilters(
                value === "enrolled"
                  ? {
                      date: filters.date || getCurrentMonthYear(),
                      status: otherFilterIntent
                        ? [...ENROLLED_NON_ACTIVE_STATUSES]
                        : lastEnrolledStatus.length > 0
                          ? lastEnrolledStatus
                          : ["active", "inactive", "newly_added"],
                    }
                  : { date: filters.date || getCurrentMonthYear() },
              );
            }}
            className="mb-4 teachers flex w-full sm:w-auto"
          >
            <ToggleGroupItem
              value="enrolled"
              aria-label="Enrolled"
              style={{
                backgroundColor:
                  patientsView === "enrolled" ? "#3463AA" : "#EEEEEE",
              }}
              className={`px-6 py-2 text-sm flex-1 md:flex-initial font-medium ${patientsView === "enrolled" ? "bg-primary-dark !important text-white" : "bg-grey-light"}`}
            >
              <User /> Enrolled
            </ToggleGroupItem>
            <ToggleGroupItem
              value="eligible"
              aria-label="Eligible"
              style={{
                backgroundColor:
                  patientsView === "eligible" ? "#3463AA" : "#EEEEEE",
              }}
              className={`px-6 py-2 text-sm flex-1 md:flex-initial font-medium ${patientsView === "eligible" ? "bg-primary-dark !important text-white" : "bg-grey-light"}`}
            >
              <User /> Eligible
            </ToggleGroupItem>
            {/* <ToggleGroupItem
              value="needs_verification"
              aria-label="Needs Verification"
              style={{
                backgroundColor:
                  patientsView === "needs_verification" ? "#3463AA" : "#EEEEEE",
              }}
              className={`px-6 py-2 text-sm flex-1 md:flex-initial font-medium ${patientsView === "needs_verification" ? "bg-primary-dark !important text-white" : "bg-grey-light"}`}
            >
              <User /> Needs Verification
            </ToggleGroupItem> */}
          </ToggleGroup>
        </div>

        <TableWithSearch
          key={`patients-${patientsView}`}
          columnPreferenceKey={`patients-${patientsView}`}
          preferenceTableName={
            patientsView === "needs_verification"
              ? "patient-list-needs-verification"
              : "patient-list"
          }
          persistFilterKeys={
            isNeedsVerificationView ? [] : ["facilityIds"]
          }
          persistFilterScopeKey={
            isNeedsVerificationView
              ? null
              : selectedOrgId &&
                  !isAllSelected &&
                  selectedOrgId !== "anthro-care"
                ? selectedOrgId
                : null
          }
          apiDataKey="patients"
          url="/patients"
          universalLoadingSkeleton
          headerActions={
            <>
              {isNeedsVerificationView ? (
                <Button
                  type="button"
                  variant="outline"
                  className="shrink-0"
                  disabled={isNeedsVerificationExporting}
                  onClick={() => void handleNeedsVerificationExport()}
                >
                  <Download className="w-4 h-4 mr-2" />
                  {isNeedsVerificationExporting ? "Downloading..." : "Download"}
                </Button>
              ) : null}
              {canExportPendingPatients ? (
                <Button
                  type="button"
                  variant="outline"
                  className="shrink-0"
                  disabled={isPendingExporting}
                  onClick={() => void handlePendingExport()}
                >
                  <Download className="w-4 h-4 mr-2" />
                  {isPendingExporting ? "Exporting..." : "Export"}
                </Button>
              ) : null}
            </>
          }
          // isDownloadData
          columnHeaders={
            isNeedsVerificationView
              ? needsVerificationPatientTableHeaders
              : patientTableHeaders
          }
          data={patients}
          setData={setPatients}
          fetchCondition={isNeedsVerificationView ? true : !!selectedOrgId}
          searchPlaceholder="Search patients ..."
          heading="Patients List"
          isActionColumn={
             !isNeedsVerificationView &&
             !(isProviderOrPractitioner || 
            isProviderOrPractitionerManager)
          }
          handleAction={(data) => {
            if (isCaretaker && !isCaretakerAssignedToPatient(data)) {
              navigate("/patients/" + data?._id);
            } else {
              navigate("/patients/" + data?._id + "/edit");
            }
          }}
          isActionDisabled={(data) => isCaretaker && !isCaretakerAssignedToPatient(data)}
          // handleEditAction={(data) => navigate("/patients/" + data?._id + "/edit")}
          isIncludeSearch
          isIgnoreSearchParams={isNeedsVerificationView}
          customFetch={
            isNeedsVerificationView ? fetchNeedsVerificationTable : undefined
          }
          params={
            isNeedsVerificationView
              ? { refreshKey }
              : {
                  orgId: selectedOrgId,
                  enrollmentStatus: patientsView,
                  refreshKey,
                }
          }
          viewData={patients.map((v: any) =>
            isNeedsVerificationView
              ? mapNeedsVerificationPatient(v)
              : {
            ...v,
            status: formatPatientListStatus(v?.status),
            // Use formatDate for DOB in listing
            dateOfBirth: formatDate(v?.dateOfBirth),
            firstName: `${v?.firstName || ""} ${v?.middleName || ""} ${v?.lastName || ""}`,
            address: v?.typeOfPatient === 'outpatient'
              ? v?.address
              : (v?.organizationId?.address || ""),
            organizationId: v?.organizationId?.organizationName,
            facility:
              (typeof v?.facilityId === "object" && v?.facilityId?.name) ||
              v?.facilityName ||
              v?.facilityId ||
              "N/A",
            assignedProviderId:
              (v?.assignedProviderId?.firstName ||
              "") + " " + (v?.assignedProviderId?.middleName || "") + " " + (v?.assignedProviderId?.lastName || "") ||
              "",
            programs : v?.programs?.map((p: any) => p?.toUpperCase()).join(", "),
            assignedCaretakerIds: v?.assignedCaretakerIds
              ?.map(
                (c: any) =>
                  (c?.firstName || "") + " " + (c?.middleName || "") + " " + (c?.lastName || "") ||
                  "",
              )
              .join(", "),
            heightValue: v?.heightValue?.includes("_")
              ? `${v.heightValue.split("_")[0]}' ${v.heightValue.split("_")[1]}"`
              : v?.heightValue,
            weightValue: v?.weightValue ?? "-",
            athenaId:
              v?.athenaId ||
              v?.athenaID ||
              v?.externalId ||
              v?.ehrId ||
              v?.patientId ||
              "-",
            eligibleForRpm: formatEligibleForRpm(
              v?.eligibleForRpm ?? v?.eligibleForRPM ?? v?.rpmEligible,
            ),
            icdCodesCount: getIcdCodesCount(v),
            patientTimezoneDisplay: formatOrganizationTimezoneDisplay(v?.resolvedTimezone) || getPatientContextTimezoneDisplay(v),
            ...(v?.caretakerMinutes ? v?.caretakerMinutes : {}),
              },
          )}
          filtersOptions={isNeedsVerificationView ? [] : filterOptions}
          filters={filters}
          setFilters={setFilters}
          defaultFilters={defaultFilters}
          isHideClearAllFilters={isNeedsVerificationView}
          isColumnSelection
          isSelectable={
            !isNeedsVerificationView &&
            user?.role?.toLowerCase() !== "provider" &&
            user?.role?.toLowerCase() !== "practitioner"
          }
          handleSearchActionsClicked={handleSearchActionsClicked}
          selectActions={isNeedsVerificationView ? [] : selectActions}
          // isHideSelect
          moreActions={
            isNeedsVerificationView ||
            isProviderOrPractitioner || 
            isProviderOrPractitionerManager
              ? []
              : [
                  {
                    label: "View ",
                    icon: <Eye className="w-4 h-4" />,
                    onClick: (data: any) => {
                      navigate("/patients/" + data?._id);
                    },
                    isShow: () => true,
                  },
                  ...(patientsView === "eligible"
                    ? [
                        {
                          label: "Enroll Patient",
                          icon: <Users className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForEnroll(data);
                            setOpenEnrollNotes(true);
                          },
                          isShow: () => true,
                        },
                      ]
                    : []),
                  ...(patientsView === "enrolled"
                    ? [
                        {
                          label: "Opt Out",
                          icon: <Users className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForOptOut(data);
                            setOpenOptOutForm(true);
                          },
                          isShow: (data: any) =>
                            data?.status !== "denied" &&
                            data?.status !== "archived" &&
                            canAdministerPatients,
                        },
                        {
                          label: "Archive",
                          icon: <Archive className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForArchive(data);
                            setOpenArchiveConfirm([true, "archive"]);
                          },
                          isShow: (data: any) =>
                            data?.status !== "archived" && canAdministerPatients,
                        },
                        {
                          label: "Unarchive",
                          icon: <Archive className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForArchive(data);
                            setOpenArchiveConfirm([true, "unarchive"]);
                          },
                          isShow: (data: any) =>
                            data?.status === "archived" && canAdministerPatients,
                        },
                        {
                          label: "Block",
                          icon: <LockKeyhole className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForArchive(data);
                            setOpenArchiveConfirm([true, "block"]);
                          },
                          isShow: (data: any) =>
                            data?.status !== "blocked" && canAdministerPatients,
                        },
                        {
                          label: "Unblock",
                          icon: <LockKeyholeOpen className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForArchive(data);
                            setOpenArchiveConfirm([true, "unblock"]);
                          },
                          isShow: (data: any) => data?.status === "blocked"  && user?.role == "admin",
                        },
                        {
                          label: "Activate",
                          icon: <CheckCircle className="w-4 h-4" />,
                          onClick: (data: any) => {
                            setSelectedPatientForActivate(data);
                            setOpenActivateConfirm(true);
                          },
                          isShow: (data: any) =>
                            data?.status === "denied" && canAdministerPatients,
                        },
                      ]
                    : []),
                ]
          }
          clickCell={[
            {
              headerKey: "currentMonthMinutes",
              isClickable: (data) => {
                return !!data?.currentMonthMinutes;
              },
              onClick: async (formdata) => {
                // console.log(formdata);
                setNursingNotes(formdata?._id); // patientId
                // try {
                //   setNursingLoading(true)
                //   const { data } = await AxiosInstance().get(
                //     "/patients/nursing-note",
                //     {
                //       params: {
                //         patientId: formdata?._id,
                //         date: getCurrentMonthYear(),
                //       },
                //     },
                //   );
                //   setNursingNotes(data?.data?.notes);
                //   setNursingLoading(false)

                // } catch (error) {
                //   setNursingLoading(false)
                //   console.log(error);
                // }
              },
            },
          ]}
        />

        <Dialog open={openOptOut} onOpenChange={setOpenOptOut}>
          <MyDialogContent heading="Opt Out Request">
            <OptOutReviewForm
              openOptOut={openOptOut}
              acceptOptOut={(id, note) => {
                acceptOptOut(id, note, true);
                // console.log("Accept:", id, note);
              }}
              rejectOptOut={(id, note) => {
                acceptOptOut(id, note, false);

                // console.log("Reject:", id, note);
              }}
            />
          </MyDialogContent>
          {/* <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Opt Out Request</DialogTitle>
          <p className="text-sm text-muted-foreground">
            Submit your reason for opting out from the program.
          </p>
        </DialogHeader>

   
      </DialogContent> */}
        </Dialog>

        {/* Enroll Notes Dialog */}
        <Dialog open={openEnrollNotes} onOpenChange={setOpenEnrollNotes}>
          <MyDialogContent heading="Enrollment Details">
          {/* <DialogContent className="max-w-3xl sm:max-w-3xl">
            <DialogHeader>
              <DialogTitle>Enrollment Details</DialogTitle>
            </DialogHeader> */}
            <EnrollNotesConsentForm
              patient={selectedPatientForEnroll}
              onClose={() => {
                setOpenEnrollNotes(false);
                setSelectedPatientForEnroll(null);
              }}
              onEnrollSuccess={() => {
                // Increment refresh key to trigger table refetch
                setRefreshKey((prev) => prev + 1);
              }}
            />
          {/* </DialogContent> */}
          </MyDialogContent>
        </Dialog>

        {/* Opt Out Form Dialog */}
        <Dialog open={openOptOutForm} onOpenChange={setOpenOptOutForm}>
          <DialogContent className="max-w-md sm:max-w-md">
            <DialogHeader>
              <DialogTitle>Opt Out Patient</DialogTitle>
            </DialogHeader>
            <OptOutForm
              patient={selectedPatientForOptOut}
              onClose={() => {
                setOpenOptOutForm(false);
                setSelectedPatientForOptOut(null);
              }}
              onOptOutSuccess={() => {
                // Increment refresh key to trigger table refetch
                setRefreshKey((prev) => prev + 1);
              }}
            />
          </DialogContent>
        </Dialog>
        <Dialog open={!!nursingNotes} onOpenChange={(o) => setNursingNotes(o)}>
          <MyDialogContent heading="Nursing Notes" className="">
            <NursingNoteTablePopup patientId={nursingNotes} />
          </MyDialogContent>
        </Dialog>

        {/* Archive Confirmation Dialog */}
        <AlertDialog
          open={openArchiveConfirm?.[0]}
          onOpenChange={(open) => {
            setOpenArchiveConfirm([open, null]);
            setArcReason("");
          }}
        >
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle className="capitalize">
                {openArchiveConfirm[1]} Patient
              </AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to {openArchiveConfirm[1]} this patient?
                This action cannot be undone.
                {selectedPatientForArchive && (
                  <div className="mt-2 font-medium">
                    Patient: {selectedPatientForArchive?.firstName}{" "}
                    {selectedPatientForArchive?.lastName}
                  </div>
                )}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <>
              <Input
                value={arcReason}
                onChange={(e) => setArcReason(e.target.value)}
                placeholder={"Reason for " + openArchiveConfirm[1]}
              />
            </>
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => {
                  setOpenArchiveConfirm([false, null]);
                  setSelectedPatientForArchive(null);
                  setArcReason("");
                }}
              >
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={async () => {
                  if (!selectedPatientForArchive?._id) {
                    toast.error("Patient information is missing");
                    return;
                  }

                  const { pr, rejectFn, resolveFn } = getPromise();
                  getPromiseToast(pr);

                  try {
                    await AxiosInstance().post(
                      `/patients/${selectedPatientForArchive._id}/${openArchiveConfirm[1]}`,
                      { reason: arcReason },
                    );
                    const action = openArchiveConfirm[1];
                    const successMessage = 
                      action === "archive" ? "Patient archived successfully" :
                      action === "unarchive" ? "Patient unarchived successfully" :
                      action === "block" ? "Patient blocked successfully" :
                      action === "unblock" ? "Patient unblocked successfully" :
                      `Patient ${action} successfully`;
                    resolveFn(successMessage);
                    setOpenArchiveConfirm([false, null]);
                    setArcReason("");

                    setSelectedPatientForArchive(null);
                    // Increment refresh key to trigger table refetch
                    setRefreshKey((prev) => prev + 1);
                  } catch (error: any) {
                    rejectFn(
                      error?.response?.data?.message ||
                        error?.message ||
                        "Failed to " + openArchiveConfirm[1] + " patient",
                    );
                  }
                }}
                className="bg-destructive text-destructive-foreground hover:bg-destructive/90 capitalize"
              >
                {openArchiveConfirm[1]}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>

        {/* Activate Confirmation Dialog */}
        <AlertDialog
          open={openActivateConfirm}
          onOpenChange={setOpenActivateConfirm}
        >
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Activate Patient</AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to activate this patient? This will change
                their status from denied to active.
                {selectedPatientForActivate && (
                  <div className="mt-2 font-medium">
                    Patient: {selectedPatientForActivate?.firstName}{" "}
                    {selectedPatientForActivate?.lastName}
                  </div>
                )}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => {
                  setOpenActivateConfirm(false);
                  setSelectedPatientForActivate(null);
                }}
              >
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={async () => {
                  if (!selectedPatientForActivate?._id) {
                    toast.error("Patient information is missing");
                    return;
                  }

                  const { pr, rejectFn, resolveFn } = getPromise();
                  getPromiseToast(pr);

                  try {
                    await AxiosInstance().post(
                      `/patients/${selectedPatientForActivate._id}/activate`,
                    );
                    resolveFn("Patient activated successfully");
                    setOpenActivateConfirm(false);
                    setSelectedPatientForActivate(null);
                    // Increment refresh key to trigger table refetch
                    setRefreshKey((prev) => prev + 1);
                  } catch (error: any) {
                    rejectFn(
                      error?.response?.data?.message ||
                        error?.message ||
                        "Failed to activate patient",
                    );
                  }
                }}
              >
                Activate
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </DashboardLayout>
  );
}

function OptOutReviewForm({ openOptOut, acceptOptOut, rejectOptOut }) {
  const [reviewNote, setReviewNote] = useState("");

  return (
    <div className="space-y-4 p-1">
      {/* Programs - READ ONLY */}
      <div className="space-y-1">
        <Label>Programs</Label>
        <Input
          disabled
          value={openOptOut?.programs?.join(", ") || ""}
          className="bg-muted"
        />
      </div>

      {/* Reason - READ ONLY */}
      <div className="space-y-1">
        <Label>Patient's Reason</Label>
        <Textarea
          disabled
          value={openOptOut?.reason || ""}
          className="bg-muted min-h-[80px]"
        />
      </div>

      {/* Review Note - ADMIN INPUT */}
      <div className="space-y-1">
        <Label>Review Note (Optional)</Label>
        <Textarea
          placeholder="Add your review note..."
          value={reviewNote}
          onChange={(e) => setReviewNote(e.target.value)}
          className="min-h-[100px]"
        />
      </div>

      {/* ACTION BUTTONS */}
      <div className="flex gap-3 pt-3">
        <Button
          variant="outline"
          className="flex-1"
          onClick={() => rejectOptOut(openOptOut?._id, reviewNote)}
        >
          Reject Request
        </Button>

        <Button
          className="flex-1"
          onClick={() => acceptOptOut(openOptOut?._id, reviewNote)}
        >
          Accept Request
        </Button>
      </div>
    </div>
  );
}

function EnrollNotesForm({
  patient,
  onClose,
  onEnrollSuccess,
}: {
  patient: any;
  onClose: () => void;
  onEnrollSuccess?: () => void;
}) {
  const [notes, setNotes] = useState("");
  const [zendeskTicketNumber, setZendeskTicketNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!notes.trim() || !zendeskTicketNumber.trim()) {
      toast.error("Please fill in all required fields");
      return;
    }

    if (!patient?._id) {
      toast.error("Patient information is missing");
      return;
    }

    setIsSubmitting(true);
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);

    try {
      const { data } = await AxiosInstance().post("/patients/enroll", {
        patientId: patient._id,
        notes: notes.trim(),
        zendeskTicketNumber: zendeskTicketNumber.trim(),
      });

      resolveFn("Patient enrolled successfully");
      onClose();
      setNotes("");
      setZendeskTicketNumber("");
      // Trigger table refresh
      if (onEnrollSuccess) {
        onEnrollSuccess();
      }
    } catch (error: any) {
      rejectFn(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to enroll patient",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Enter Notes */}
      <div className="space-y-2">
        <Label htmlFor="notes">Enrollment Form*</Label>
        <Textarea
          id="notes"
          placeholder="Enrollment note..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="min-h-[100px] resize-none"
          required
        />
      </div>

      {/* Enter Zendesk Ticket Number */}
      <div className="space-y-2">
        <Label htmlFor="zendesk-ticket">Enter Consent Proof*</Label>
        <Input
          id="zendesk-ticket"
          placeholder="Consent Proof"
          value={zendeskTicketNumber}
          onChange={(e) => setZendeskTicketNumber(e.target.value)}
          required
        />
      </div>

      {/* Confirm Button */}
      <div className="flex justify-end pt-2">
        <Button
          onClick={handleSubmit}
          disabled={
            isSubmitting || !notes.trim() || !zendeskTicketNumber.trim()
          }
        >
          {isSubmitting ? "Submitting..." : "Confirm"}
        </Button>
      </div>
    </div>
  );
}

function OptOutForm({
  patient,
  onClose,
  onOptOutSuccess,
}: {
  patient: any;
  onClose: () => void;
  onOptOutSuccess?: () => void;
}) {
  const [note, setNote] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!note.trim()) {
      toast.error("Please enter a note");
      return;
    }

    if (!patient?._id) {
      toast.error("Patient information is missing");
      return;
    }

    setIsSubmitting(true);
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);

    try {
      const { data } = await AxiosInstance().post("/patients/opt-out", {
        patientId: patient._id,
        note: note.trim(),
      });

      resolveFn("Patient opted out successfully");
      onClose();
      setNote("");
      // Trigger table refresh
      if (onOptOutSuccess) {
        onOptOutSuccess();
      }
    } catch (error: any) {
      rejectFn(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to opt out patient",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Enter Note */}
      <div className="space-y-2">
        <Label htmlFor="opt-out-note">Enter Note*</Label>
        <Textarea
          id="opt-out-note"
          placeholder="Enter note for opt-out..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="min-h-[100px] resize-none"
          required
        />
      </div>

      {/* Submit Button */}
      <div className="flex justify-end pt-2">
        <Button onClick={handleSubmit} disabled={isSubmitting || !note.trim()}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </div>
  );
}
